import { MentionInputPlugin, MentionPlugin } from '@platejs/mention/react'

import { MentionElement } from './MentionElement'

type RichTextFieldMentionOptions = Pick<
  typeof MentionPlugin.options,
  'trigger'
> & {
  inputComponent: Parameters<typeof MentionInputPlugin.withComponent>[0]
}

type RichTextFieldMentionKit = readonly [
  typeof MentionPlugin,
  typeof MentionInputPlugin,
]

const createRichTextFieldMentionKit = ({
  inputComponent,
  trigger = '@',
}: RichTextFieldMentionOptions): RichTextFieldMentionKit => [
  MentionPlugin.configure({ options: { trigger } }).withComponent(
    MentionElement,
  ),
  MentionInputPlugin.withComponent(inputComponent),
]

export { createRichTextFieldMentionKit }
export type { RichTextFieldMentionKit, RichTextFieldMentionOptions }
